module.exports = __webpack_public_path__ + "media/images/hitfun/icon.mainmenu.subscribes-b44b8d787609b9ac4f9ec38fc1ce6548.svg";